export const OUTFIELD_STATS = ["PAC", "SHO", "PAS", "DRI", "DEF", "PHY"];
export const GK_STATS = ["DIV", "HAN", "KIC", "REF", "SPE", "POS"];

const GK_DETAIL_KEY = {
  DIV: "diving",
  HAN: "handling",
  KIC: "kicking",
  REF: "reflexes",
  SPE: "speed",
  POS: "positioning",
};

export function isGoalkeeper(player) {
  return player?.pos === "GK" || !!player?.details?.goalkeeping;
}

// Tailwind classes for a position chip (share card etc.),
// colored by position group.
export function posBadgeClass(pos) {
  if (pos === "GK") return "bg-amber-400 text-amber-950";
  if (["CB", "LB", "RB", "LWB", "RWB"].includes(pos))
    return "bg-emerald-500 text-emerald-950";
  if (["CDM", "CM", "CAM", "LM", "RM"].includes(pos))
    return "bg-sky-500 text-sky-950";
  return "bg-rose-500 text-rose-950";
}

// The 6 stat keys + values to show in a compact strip.
// Keepers get DIV/HAN/KIC/REF/SPE/POS from details.goalkeeping;
// everyone else gets the outfield six from attrs.
export function displayStats(player) {
  if (isGoalkeeper(player) && player?.details?.goalkeeping) {
    const gk = player.details.goalkeeping;
    return GK_STATS.map((key) => ({ key, value: gk[GK_DETAIL_KEY[key]] }));
  }
  const a = player?.attrs || {};
  return OUTFIELD_STATS.map((key) => ({ key, value: a[key] }));
}
